import React, {Component} from 'react';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import toastr from "toastr";
import _ from 'lodash';
import {getJwt} from '../../../services/authService';

import http from "../../../services/httpService";

import {Menu, MenuItem, Tag, Spinner, Popover, Position, Tooltip, Classes, Icon} from "@blueprintjs/core";

import Theme from '../../common/MuiTheme';

import CampaignDetailsModal from "../../modals/CampaignDetailsModal";
import sizeMe from 'react-sizeme';
import ChartLoader from '../../utils/chart-loader';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class WebPushCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: '',
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            selectedSource: this.props.selectedSource,
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: true,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: '',
            selectedSubTypeFinished: '',
            selectedType: '',
            selectedTypeFinished: '',
            rowHeights: [100, 100, 100, 100, 100],
            lastColumnWidth: '',

            //modal data
            campaignDetailsModal: false,
            campaignId: '',
            sendFrom: '',
            sendTime: {
                date: '',
                time: ''
            },
            message: '',
            segments: ['everything'],
            summary: {
                delivered: '',
                deliveredPercentage: '',
                notDelivered: '',
                notDeliveredPercent: '',
                buffered: '',
                clicked: ''
            }

        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    openModal = async (index) => {
        let item = this.state.posts[index]
        //console.log('index: ', index)
        //console.log('post: ', this.state.posts[index])

        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';

        let sent = item?.data?.sent_wp_post_total ?? ''
        let delivered = sent
        let deliveredPercentage = sent === 0 ? '0%' : (delivered / sent) * 100 + '%'
        let notDelivered = sent - delivered
        let notDeliveredPercentage = delivered === 0 ? '0%' : (notDelivered / sent) * 100 + '%'
        let tags = ['everyone']
        let newSendTime = {
            date: date,
            time: time
        }
        let clicked = this.state?.posts[index]?.data?.opened_post_total ?? ''
        let newSummary = {
            delivered: delivered,
            deliveredPercentage: sent === 0 ? '0%' : deliveredPercentage,
            notDelivered: sent === 0 ? 0 : notDelivered,
            notDeliveredPercentage: sent === 0 ? '0%' : notDeliveredPercentage,
            buffered: '',
            clicked: clicked,
            clickedPercent: clicked === 0 ? '0%' : (clicked / delivered) * 100 + '%'
        }

        this.setState({
            campaignId: this.state.posts[index].id,
            message: this.state.posts[index].content,
            campaignDetailsModal: true,
            segments: this.state?.posts[index]?.data?.tags ?? tags,
            sendTime: newSendTime,
            summary: newSummary,
        })
    }

    getPostsData = async () => {


        try {
            await this.setState({loader: true})
            const pageSize = await this.state.pageSize;
            let selectedSubType = await this.props.selectedSubType;
            let selectedType = await this.props.selectedType;
            let selectedSource = this.props.selectedSource;
            // let selectedSource = '1160';
            // let selectedSource = '1299';

            let apiCallType = await selectedSubType.name === 'Show All' ? 'all_webpush_posts' :
                selectedSubType.name === 'Autopush' ? 'webpush_auto_posts' : 'webpush_custom_posts';

            const result = await http.get('api/' + apiCallType + '/page_size/' + this.state.pageSize + '/feed/' + selectedSource + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});
            const data = await result.data;
            // console.log('Ojha aloha: ', data)
            //this.props.selectedSubType.name === 'Multiple Custom Links' ? [200,200,200,200,300,300,300,200,200,200] : [100,100,100,100,100,100,100,100,100,100],
            let rowHeights = await data.posts.map(() => 100);
            //console.log('posts: ', data)
            await this.setState({
                rowHeights,
                posts: data.posts ? data.posts.length > 0 ? data.posts : '' : '',
                selectedSubType: selectedSubType.name,
                selectedType: selectedType.name,
                totalPosts: data.total_posts,
                totalPages: data.total_pages,
                lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages),
                lastPageSize: ((data.total_posts % this.state.pageSize) === 0) ? data.total_posts === 0 ? 0 : this.state.pageSize :
                    ((data.total_posts % this.state.pageSize) < 0) ? data.total_posts : data.total_posts % this.state.pageSize,
                selectedSubTypeFinished: this.props.selectedSubType.name,
                selectedTypeFinished: this.props.selectedType.name,
                loader: data.posts.length < 1 ? false : true
            })
            if (this.state.loader) {
                this.setState({loader: false})
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                this.setState({loader: false})
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    async componentDidMount() {


        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

    }


    componentDidUpdate = async () => {

        if (this.state.selectedAdAccount !== this.props.user.add_account_id) {
            //console.log('component did update started')
            this.setState({
                currentPage: 1,
                selectedAdAccount: this.props.user.add_account_id
            })
        }

        if ((this.state.selectedSubType !== this.props.selectedSubType.name) && this.state.selectedSubType && this.props.selectedSubType) {
            this.setState({
                loader: true,
                currentPage: 1,
                selectedSubType: this.props.selectedSubType.name,
            })
            this.getPostsData();
        }

        if ((this.state.selectedType !== this.props.selectedType.name) && this.state.selectedType && this.props.selectedType) {
            this.setState({
                loader: true,
                currentPage: 1,
                selectedType: this.props.selectedType.name
            })
            this.getPostsData();
        }

        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('selected source changed - component did updated')

            this.handlePageChange(1, this.props.selectedSource, "all");
            this.getPostsData();
            this.setState({selectedSource: this.props.selectedSource})
        }
        //this.getPreview();

    }

    handlePageChange = async (number) => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })
        await this.getPostsData()
    }
    rerunCampaign = (e, campaign) => {
        e.stopPropagation()
        this.props.history.push('/new/web-push', campaign)

    }
    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630,
                    "link_data": {
                        "call_to_action": {
                            "type": "USE_APP",
                            "value": {
                                "link": link
                            }
                        },
                        "description": "Description here",
                        "link": link,
                        "message": "Test message",
                        "name": "Name here",
                        "picture": link
                    }
                }
                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    noWebPushRenderer = () => {
        let webpush_platform_enabled = this.props.platforms_enabled && this.props.platforms_enabled.indexOf("wp") > -1;

        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/url_shortener_my_campaigns.gif" alt='Shortener gif'/>
            {
                webpush_platform_enabled ?
                    <h3>There is no data for this type of messages.</h3>
                    :
                    <h3>Webpush is not enabled for {this.props.selectedSourceName}.</h3>
            }

            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                {
                    webpush_platform_enabled ?
                        <button
                            onClick={() => this.props.history.push('/new/web-push')}
                            className=' btn-action margin-bottom-10'>
                            Start a Web Push campaign
                        </button>
                        :
                        <button
                            onClick={() => this.props.history.push('/channels/web-push')}
                            className=' btn-action margin-bottom-10'>
                            Enable
                        </button>
                }
            </div>
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    render() {

        const columns = [
            {
                name: "type",
                label: " ",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <i onClick={() => this.openModal(tableMeta.rowIndex)}
                                  className={item.type === 'custom_single' ? 'fas fa-eye type-icon' : 'fas fa-eye type-icon'}></i>
                    }
                }
            },
            {
                name: "sent",
                label: " Sent ",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className='text-light-blue min-width-70'>
                            <i className="fas fa-paper-plane type-icon"></i>{item?.data?.sent_wp_post_total ? item?.data?.sent_wp_post_total : ''}
                        </div>
                    }
                }
            },
            {
                name: "clicked",
                label: "Clicked",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className="text-light-blue">
                            <i className="fas fa-envelope-open"
                               style={{color: '#18A9E3'}}></i> {item?.data?.opened_wp_post_total ?? ''}
                        </div>
                    }
                }
            },
            {
                name: "clicked_percentage",
                label: "%",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className='text-light-grey'>
                            {item?.data?.percent_wp_post_total ? item.data.percent_wp_post_total : ''}
                            {item?.data?.percent_wp_post_total ? item.data.percent_wp_post_total === 0 ? '%' : '' : ''}
                        </div>
                    }
                }
            },
            {
                name: "image",
                label: "Image",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];

                        return <div className='image-cell'>
                            {item.image ?
                                <img className='viber-image' src={item.image} alt='Webpush image'/>
                                :
                                ''
                            }
                        </div>
                    }
                }
            },
            {
                name: "title",
                label: "Title",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div>{item.title}</div>
                    }
                }
            },
            {
                name: "link",
                label: "Link",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let link = '';
                        if (item.message && item.message.components && item.message.components.length) {
                            item.message.components.map(component => component.type === 'button' ? link = component.button.callback : '')
                        }
                        return <div className='mui-column-wrapper'>
                            <a href={item.short_url} target="_blank"><i className="fas fa-link type-icon"></i></a>
                        </div>
                    }
                }
            },
            {
                name: "segments",
                label: "Segments",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        // console.log('item: ', item)
                        return <div>
                            {
                                item?.data?.tags_wp?.length ?

                                    item.data.tags_wp.length > 3 ?

                                        <React.Fragment>

                                            <Popover
                                                content={
                                                    <div className='remaining-tags padding-10'>
                                                        {item.data.tags_wp.map(tag =>
                                                            <Tag
                                                                className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                                    'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                                        tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                                                key={tag}
                                                            >
                                                                {tag.toLowerCase()}
                                                            </Tag>
                                                        )}
                                                    </div>
                                                }
                                                position={Position.TOP}>
                                                <div className="remaining-tags-container">
                                                    {item.data.tags_wp.length}
                                                </div>
                                            </Popover>
                                        </React.Fragment>
                                        :
                                        item.data.tags_wp.map(tag =>
                                            <Tag
                                                className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                    'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                        tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                                key={tag}
                                            >
                                                {tag.toLowerCase()}
                                            </Tag>) :

                                    <Tag>everyone</Tag>

                            }
                        </div>
                    }
                }
            },
            {
                name: "sent_at",
                label: "Sent at",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
                        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
                        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';

                        return <div className='mui-column-wrapper min-width-80'>
                            <p style={{marginBottom: 5}}>{date}</p>
                            <p style={{color: 'rgb(164, 175, 183)'}}>{time}</p>
                        </div>
                    }
                }
            },
            {
                name: "sent_at_timezone",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        //console.info('item: ', item)
                        return (
                            <div className='text-center'>
                                <Tooltip
                                    position={Position.TOP}
                                    className={Classes.TOOLTIP_INDICATOR}
                                    content={<span>Create new campaign with the same data</span>}
                                    isOpen={this.state.isOpen}
                                >
                                    <Icon className='rerun-icon' onClick={(e) => this.rerunCampaign(e, item)}
                                          icon='duplicate'/>
                                </Tooltip>
                            </div>
                        )
                    }
                }
            },
        ];

        const options = {
            serverSide: true,
            count: this.state.totalPosts,
            filterType: 'none',
            selectableRows: 'none',
            rowsPerPage: this.state.pageSize,
            viewColumns: false,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            onChangeRowsPerPage: (number) => this.handleChangeCampaignsNumberPerPage(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100],
            rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.setState({rowsSelected});
                this.handleCheck(rowsSelected)
                //console.log('currentRowsSelected: ', currentRowsSelected, ' allRowsSelected:', allRowsSelected, ' rowsSelected:', rowsSelected)
            }

        };
        return (

            <React.Fragment>
                {/*{ document.querySelector('.bp3-table-quadrant-scroll-container') ?*/}
                {/*    <div>*/}
                {/*        {document.querySelector('.bp3-table-quadrant-scroll-container').scroll(scrollLeft+1, scrollTop+1)}}*/}
                {/*    </div> : ''}*/}
                <div className="d-block">
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    {/*{ console.log( (!this.state.posts || this.state.posts.length < 1), !this.state.loader)}*/}
                    {/*Proveriti ovaj uslov*/}
                    <div className='margin-bottom-10'>
                    </div>
                    {
                        this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            (!this.state.posts || this.state.posts.length < 1) && !this.state.loader ?
                                this.noWebPushRenderer()
                                :
                                <MuiThemeProvider theme={this.getMuiTheme()}>
                                    <MUIDataTable
                                        title={""}
                                        data={this.state.posts}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                    }
                </div>
                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
                <CampaignDetailsModal
                    showModal={this.state.campaignDetailsModal}
                    handleClose={() => this.setState({campaignDetailsModal: false})}
                    maxWidth={540}
                    history={this.props.history}
                    campaignId={this.state.campaignId}
                    sendFrom={this.state.sendFrom}
                    sendTime={this.state.sendTime}
                    message={this.state.message}
                    segments={this.state.segments}
                    summary={this.state.summary}
                />

            </React.Fragment>
        )
    }
}

export default sizeMe()(WebPushCampaignPerformance);